export const NAVIGATION_BUTTON_BASE_CLASSES = [
  'tw:relative',
  'tw:-ml-px',
  'tw:inline-flex',
  'tw:items-center',
  'tw:justify-center',
  'tw:border',
  'tw:border-solid',
  'tw:border-sq-disabled-gray',
  'tw:bg-sq-white',
  'tw:text-sq-text-color',
  'tw:no-underline',
  'tw:hover:text-sq-theme-dark',
  'tw:focus:text-sq-theme-dark',
  'tw:active:text-sq-theme-dark',
  'tw:dark:border-sq-dark-disabled-gray',
  'tw:dark:bg-sq-dark-background',
  'tw:dark:text-sq-dark-text',
  'tw:dark:hover:text-sq-theme-dark-dark',
  'tw:dark:focus:text-sq-theme-dark-dark',
  'tw:dark:active:text-sq-theme-dark-dark',
  'tw:cursor-pointer',
];

export const NAVIGATION_BUTTON_CLASS_BY_SIZE = {
  small: 'tw:min-w-6 tw:min-h-6',
  normal: 'tw:min-w-8 tw:min-h-[34px]',
} as const;

export const DISABLED_NAVIGATION_BUTTON_CLASSES = [
  'tw:cursor-not-allowed',
  'tw:opacity-50',
  'tw:pointer-events-none',
  'tw:hover:text-sq-text-color',
  'tw:focus:text-sq-text-color',
  'tw:active:text-sq-text-color',
  'tw:dark:hover:text-sq-dark-text',
  'tw:dark:focus:text-sq-dark-text',
  'tw:dark:active:text-sq-dark-text',
];

export const ACTIVE_NAVIGATION_BUTTON_CLASSES = [
  'tw:z-10',
  'tw:border-sq-theme-dark!',
  'tw:bg-sq-theme-dark!',
  'tw:text-sq-white!',
  'tw:hover:text-sq-white!',
  'tw:focus:text-sq-white!',
  'tw:active:text-sq-white!',
  'tw:dark:border-sq-theme-dark-dark!',
  'tw:dark:bg-sq-theme-dark-dark!',
  'tw:dark:text-sq-white!',
  'tw:dark:hover:text-sq-white!',
  'tw:dark:focus:text-sq-white!',
  'tw:dark:active:text-sq-white!',
];

export const BREAK_NAVIGATION_ITEM_BASE_CLASSES = [
  'tw:inline-flex',
  'tw:min-h-8',
  'tw:min-w-8',
  'tw:items-center',
  'tw:justify-center',
  'tw:bg-transparent',
  'tw:text-sq-text-color',
  'tw:dark:text-sq-dark-text',
];

export const SELECT_WIDTH_CLASS_BY_SIZE = {
  small: 'tw:w-[55px]',
  normal: 'tw:w-[65px]',
} as const;

export const CONTROLS_SPACING_CLASS_BY_SIZE = {
  small: 'tw:gap-1',
  normal: 'tw:gap-1.5',
} as const;

export const NAV_BUTTON_PADDING_CLASS_BY_SIZE = {
  small: 'tw:px-[6px] tw:py-px',
  normal: 'tw:px-[15px] tw:py-[6px]',
} as const;

export const GO_TO_PAGE_WRAPPER_CLASS_BY_SIZE = {
  small: 'tw:ml-[5px]',
  normal: 'tw:my-1.5',
} as const;

export const ITEM_COUNT_WRAPPER_CLASS_BY_SIZE = {
  small: '',
  normal: 'tw:my-1.5',
} as const;

export const ITEM_COUNT_LABEL_CLASS_BY_SIZE = {
  small: '',
  normal: 'tw:ml-[10px]',
} as const;
